import * as React from 'react';
import { RadioButtonGroup } from '@chakra-ui/core';
import { Button } from '../button';

type SegmentedControlProps = any & {
    size?: string
    spacing?: number | string
    variant?: string
    variantColor?: string
    selectedVariant?: string
    selectedVariantColor?: string
}

const Segment = React.forwardRef((props: any, ref: any) => {
    const {
        isChecked,
        isDisabled,
        value,
        variant,
        variantColor,
        selectedVariant,
        selectedVariantColor,
        ...rest
    } = props;
    return (
        <Button
            ref={ref}
            variant={isChecked ? selectedVariant : variant}
            variantColor={isChecked ? selectedVariantColor : variantColor}
            aria-checked={isChecked}
            role="radio"
            isDisabled={isDisabled}
            {...rest}
        />
    );
});

const SegmentedControl: React.FC<SegmentedControlProps> = (props: any): React.ReactElement => {
    const {
        size,
        variant,
        variantColor,
        selectedVariant,
        selectedVariantColor,
        children,
        ...rest
    } = props;

    const styledChildren = React.Children.map(children, (child: any, index: number) => {
        if (child) {
            const childProps = { ...child.props };
            childProps.size = size;
            childProps.variant = variant;
            childProps.variantColor = variantColor;
            childProps.selectedVariant = selectedVariant;
            childProps.selectedVariantColor = selectedVariantColor;
            childProps.flexGrow = 1;
            return (
                <Segment {...childProps} />
            );
        }
        return child;
    });

    return (
        <RadioButtonGroup display="flex" isInline {...rest}>
            {styledChildren}
        </RadioButtonGroup>
    );
};

SegmentedControl.defaultProps = {
    variant: 'solid',
    selectedVariantColor: 'brand'
};

export { Segment };

export default SegmentedControl;
